import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const AddEvent = () => {
  const [formData, setFormData] = useState({});
  const [provOptions, setProvOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [ldcOptions, setLdcOptions] = useState([]);
  const [ldcsFullData, setLdcsFullData] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);

  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalFilterResults, setModalFilterResults] = useState([]);
  const [importImageLink, setImportImageLink] = useState("");

  const breadcrumb = {
    current_section: "Eventi",
    sections: [
      { name: "Eventi", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));
        setProvOptions(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/ldc/ldcget`,
          fetchOptions
        );
        const result = await response.json();
        setLdcOptions(
          convertIntoSelect2Options(result.return.ldc, "id", "nome")
        );
        setLdcsFullData(result.return.ldc);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
    fetchLDCs();
  }, []);

  useEffect(() => {
    const fetchFilteredLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllLDC?provinceId=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}`,
          fetchOptions
        );
        const result = await response.json();
        setLdcOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchFilteredLDCs();
  }, [selectedProvince, selectedCity]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${formData.idprovincia}`,
          fetchOptions
        );
        const result = await response.json();
        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    if (formData.idprovincia) {
      fetchCities();
    }
  }, [formData.idprovincia]);

  const handleProvinceChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idprovincia: e?.value }));
    setSelectedProvince(e?.value);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idcomune: e?.value }));
    setSelectedCity(e?.value);
  };

  const handleLDCChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      longitude: ldcsFullData.find((ldc) => ldc.id == e?.value)?.longitude,
      latitude: ldcsFullData.find((ldc) => ldc.id == e?.value)?.latitude,
      indirizzo: ldcsFullData.find((ldc) => ldc.id == e?.value)?.indirizzo,
      idprovincia: ldcsFullData.find((ldc) => ldc.id == e?.value)?.idprovincia,
      idcomune: ldcsFullData.find((ldc) => ldc.id == e?.value)?.idcomune,
      idldc: e?.value,
    }));
    setSelectedCity(ldcsFullData.find((ldc) => ldc.id == e?.value)?.idcomune);
    setSelectedProvince(
      ldcsFullData.find((ldc) => ldc.id == e?.value)?.idprovincia
    );
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleModalProvinceChange = (e) => {
    setModalData((prevData) => ({
      ...prevData,
      provincia: e?.label,
      idprovincia: e?.value,
    }));
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();
        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };
  const handleModalCityChange = (e) => {
    setModalData((prevData) => ({
      ...prevData,
      comune: e?.label,
      idcomune: e?.value,
    }));
  };
  const handleFilterModalData = async () => {
    const QUANTITY_FOR_REQUEST = 10;

    if (modalData.provincia && !modalData.comune) {
      alert(
        "Per la ricerca per provincia è necessario selezionare anche un comune."
      );
      return;
    }

    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "GET"
    );

    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/getOpenDataEvents?testo=${
        modalData.testo ?? ""
      }&provincia=${modalData.provincia ?? ""}&comune=${
        modalData.comune ?? ""
      }&quantita=${QUANTITY_FOR_REQUEST}`,
      fetchOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          setModalFilterResults(data);
        } else {
          alert("Nessun risultato trovato");
          setModalFilterResults([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const calculateLatLon = (address, comune, provincia) => {
    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "GET"
    );
    fetch(
      `${axios.defaults.baseBFFUrl}/fe/getLatLon?indirizzo=${address}&comune=${comune}&provincia=${provincia}`,
      fetchOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setFormData((prevData) => ({
            ...prevData,
            latitude: data.latitudine,
            longitude: data.longitudine,
          }));
        } else {
          alert("Nessun risultato trovato");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handleSave = () => {
    if (!formData.idprovincia) {
      alert("Il campo Provincia è obbligatorio.");
      return;
    }
    if (!formData.idcomune) {
      alert("Il campo Comune è obbligatorio.");
      return;
    }
    if (!formData.datainizio) {
      alert("Il campo Data inizio è obbligatorio.");
      return;
    }
    if (!formData.orainizio) {
      alert("Il campo Ora inizio è obbligatorio.");
      return;
    }
    if (!formData.datafine) {
      alert("Il campo Data fine è obbligatorio.");
      return;
    }
    if (!formData.orafine) {
      alert("Il campo Ora fine è obbligatorio.");
      return;
    }
    if (!formData.nomeevento) {
      alert("Il campo Titolo è obbligatorio.");
      return;
    }
    if (!formData.longitude) {
      alert("Il campo Longitudine è obbligatorio.");
      return;
    }
    if (!formData.latitude) {
      alert("Il campo Latitudine è obbligatorio.");
      return;
    }
    if (!formData.indirizzo) {
      alert("Il campo Indirizzo è obbligatorio.");
      return;
    }

    if (formData.datainizio > formData.datafine) {
      alert("La data di inizio non può essere successiva alla data di fine.");
      return;
    }
    const fetchOptions = getFetchOptions(
      "application/json",
      { event: formData },
      "POST"
    );

    fetch(`${axios.defaults.baseBFFUrl}/fe/addEvent`, fetchOptions).then(
      (response) => {
        if (response.error) {
          alert(
            "Errore durante il salvataggio dell'evento, controllare i dati inseriti"
          );
          return;
        } else {
          window.location = "/events";
        }
      }
    );
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/events">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista eventi
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* Event Management */}
      <div className="card custom-card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span>Dati generali</span>
          <button
            className="btn btn-primary"
            onClick={() => setModalShow(true)}
          >
            Importa da Opendata
          </button>
        </div>
        <div className="card-body">
          {/* Modal */}
          {modalShow && (
            <div className="modal-backdrop-custom">
              <div className="modal show d-block" tabIndex="-1" role="dialog">
                <div
                  className="modal-dialog modal-dialog-centered modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        Importa da Opendata{" "}
                        <span className="text-danger fs-11">
                          10 eventi caricati per volta, inserire testo per
                          ricerca piu` specifica (attendere qualche secondo per
                          il caricamento)
                        </span>
                      </h5>
                      <button
                        type="button"
                        className="btn btn-close"
                        onClick={() => setModalShow(false)}
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row mb-3">
                        <div className="col">
                          <label htmlFor="filterName">Testo </label>
                          <input
                            id="filterName"
                            name="filterName"
                            className="form-control"
                            placeholder="Inserisci nome..."
                            onChange={(e) =>
                              setModalData((prevData) => ({
                                ...prevData,
                                testo: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="filterProvince">Provincia</label>
                          <Select
                            options={provOptions}
                            id="filterProvince"
                            name="filterProvince"
                            placeholder="Scegli provincia..."
                            isSearchable
                            isClearable
                            onChange={handleModalProvinceChange}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="filterCity">Comune</label>
                          <Select
                            options={cityOptions}
                            id="filterCity"
                            name="filterCity"
                            placeholder="Scegli comune..."
                            isSearchable
                            isClearable
                            onChange={handleModalCityChange}
                          />
                        </div>
                        <div className="col d-flex align-items-end justify-content-end me-2">
                          <button
                            className="btn btn-primary mt-4"
                            onClick={handleFilterModalData}
                          >
                            <i className="bi bi-search"></i> Cerca
                          </button>
                        </div>
                      </div>
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Descrizione</th>
                              <th>Provincia</th>
                              <th>Comune</th>
                              <th>Data Inizio</th>
                              <th>Data Fine</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modalFilterResults?.map((result) => (
                              <tr key={result.id}>
                                <td>{result.nome}</td>
                                <td title={result.descrizione}>
                                  {result.descrizione?.length > 100
                                    ? `${result.descrizione.slice(0, 100)}...`
                                    : result.descrizione}
                                </td>
                                <td>{result.provincia}</td>
                                <td>{result.comune}</td>
                                <td>
                                  {result.datainizio
                                    ? new Date(
                                        result.datainizio
                                      ).toLocaleDateString("it-IT")
                                    : ""}
                                </td>
                                <td>
                                  {result.datafine
                                    ? new Date(
                                        result.datafine
                                      ).toLocaleDateString("it-IT")
                                    : ""}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={async () => {
                                      let openDataProvinceId = provOptions.find(
                                        (option) =>
                                          option.label === result.provincia
                                      )?.value;

                                      let response = await fetch(
                                        `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${openDataProvinceId}`,
                                        getFetchOptions(
                                          "application/x-www-form-urlencoded",
                                          [],
                                          "GET"
                                        )
                                      );
                                      let towns = await response.json();

                                      const convertedCityOptions =
                                        convertIntoSelect2Options(
                                          towns,
                                          "id",
                                          "nome"
                                        );
                                      await setCityOptions(
                                        convertedCityOptions
                                      );

                                      let openDataTownId =
                                        convertedCityOptions.find(
                                          (option) =>
                                            option.label === result.comune
                                        )?.value;

                                      setFormData((prevData) => ({
                                        ...prevData,
                                        nome: result.nome,
                                        idprovincia:
                                          openDataProvinceId ||
                                          modalData.idprovincia,
                                        idcomune:
                                          openDataTownId || modalData.idcomune,
                                        indirizzo: result.indirizzo,
                                        nomeevento: result.nome,
                                        eventidescrizione:
                                          result.descrizione.slice(0, 100),
                                        datainizio: result.datainizio,
                                        orainizio: result.orainizio,
                                        datafine: result.datafine,
                                        orafine: result.orafine,
                                      }));

                                      calculateLatLon(
                                        result.indirizzo,
                                        modalData.comune,
                                        modalData.provincia
                                      );

                                      const fetchFilteredLDCs = async () => {
                                        try {
                                          const fetchOptions = getFetchOptions(
                                            "application/x-www-form-urlencoded",
                                            [],
                                            "GET"
                                          );
                                          const response = await fetch(
                                            `${
                                              axios.defaults.baseBFFUrl
                                            }/fe/getAllLDC?provinceId=${
                                              (openDataProvinceId ||
                                                modalData.idprovincia) ??
                                              ""
                                            }&townId=${
                                              (openDataTownId ||
                                                modalData.idcomune) ??
                                              ""
                                            }`,
                                            fetchOptions
                                          );
                                          const result = await response.json();
                                          setLdcOptions(
                                            convertIntoSelect2Options(
                                              result,
                                              "id",
                                              "nome"
                                            )
                                          );
                                        } catch (error) {
                                          console.error(error);
                                        }
                                      };
                                      fetchFilteredLDCs();
                                      setImportImageLink(result.immagine);
                                      setModalShow(false);
                                    }}
                                  >
                                    Seleziona
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setModalShow(false)}
                      >
                        Chiudi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row row-cols-1 row-cols-lg-3 mb-3">
            <div className="col">
              <label htmlFor="province">
                Provincia <b>*</b>
              </label>
              <Select
                options={provOptions}
                id="province"
                name="province"
                value={provOptions.filter(function (option) {
                  return option.value === Number(formData.idprovincia);
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="city">
                Comune <b>*</b>
              </label>
              <Select
                options={cityOptions}
                id="city"
                name="city"
                value={cityOptions?.filter(function (option) {
                  return option.value === Number(formData.idcomune);
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="idldc">Luogo della cultura</label>
              <Select
                options={ldcOptions}
                id="idldc"
                name="idldc"
                value={ldcOptions?.filter(function (option) {
                  return option.value === Number(formData.idldc);
                })}
                onChange={handleLDCChange}
                classNames={"form-control"}
                placeholder="Scegli luogo..."
                isSearchable
                isClearable
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6 col-lg-2">
              <label htmlFor="datainizio">
                Data inizio <b>*</b>
              </label>
              <input
                id="datainizio"
                name="datainizio"
                type="date"
                className="form-control"
                value={formData.datainizio || ""}
                onChange={(e) =>
                  handleInputChange("datainizio", e.target.value)
                }
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="orainizio">
                Ora inizio <b>*</b>
              </label>
              <input
                id="orainizio"
                name="orainizio"
                type="time"
                className="form-control"
                value={formData.orainizio || ""}
                onChange={(e) => handleInputChange("orainizio", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="datafine">
                Data fine <b>*</b>
              </label>
              <input
                id="datafine"
                name="datafine"
                type="date"
                className="form-control"
                value={formData.datafine || ""}
                onChange={(e) => handleInputChange("datafine", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="orafine">
                Ora fine <b>*</b>
              </label>
              <input
                id="orafine"
                name="orafine"
                type="time"
                className="form-control"
                value={formData.orafine || ""}
                onChange={(e) => handleInputChange("orafine", e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-4">
              <label htmlFor="nomeevento">
                Titolo <b>*</b>
              </label>
              <input
                id="nomeevento"
                name="nomeevento"
                type="text"
                value={formData.nomeevento || ""}
                onChange={(e) =>
                  handleInputChange("nomeevento", e.target.value)
                }
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6 col-lg-3 col-xl-2">
              <label htmlFor="longitudine">
                Longitudine <b>*</b>
              </label>
              <input
                id="longitudine"
                name="longitudine"
                type="text"
                className="form-control"
                value={formData.longitude || ""}
                onChange={(e) => handleInputChange("longitude", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-3 col-xl-2">
              <label htmlFor="latitudine">
                Latitudine <b>*</b>
              </label>
              <input
                id="latitudine"
                name="latitudine"
                type="text"
                className="form-control"
                value={formData.latitude || ""}
                onChange={(e) => handleInputChange("latitude", e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-8">
              <label htmlFor="indirizzo">
                Indirizzo <b>*</b>
              </label>
              <input
                id="indirizzo"
                name="indirizzo"
                type="text"
                className="form-control"
                value={formData.indirizzo || ""}
                onChange={(e) => handleInputChange("indirizzo", e.target.value)}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <label htmlFor="eventidescrizione">Breve descrizione</label>
              <textarea
                id="eventidescrizione"
                name="eventidescrizione"
                className="form-control"
                value={formData.eventidescrizione || ""}
                onChange={(e) =>
                  handleInputChange("eventidescrizione", e.target.value)
                }
              ></textarea>
            </div>
          </div>

          {/* Save Button */}
          <div className="saveButtonContainer">
            <button
              id="savePlaceBtn"
              name="savePlaceBtn"
              className="btn btn-success saveButton"
              type="button"
              onClick={handleSave}
            >
              &nbsp;Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEvent;
